
var TextSearcher = require('./TextSearcher'),
    Hit = require('./hit/hit'),
    Hits = require('./hit/hits'),
    FindAndRedactNoteModelConverter = require('../noteModelConverter'),
    TopDownResults = require('./topDownResults/topDownResults'),
    PageTree = require('./pageHierarchy/PageTree'),
    SearchTree = require('./searchHierarchy/SearchTree');


var SearchResults = function() {

    this.topDownResults = new TopDownResults(); // Array of { note, searchId, search, pageId } -- TODO: call something more approp? ( notes with info ? ) -- this is crucial for the page notes ( broken by page, by search -- and saving )

    // collection of all hits across notes and searches with references back to searches and pageNotes
    this.hits = new Hits();
    this.pageTree = new PageTree();
    this.searchTree = new SearchTree();

};


_.extend( SearchResults.prototype, {

    /**
     * Note: we don't clear here ... do that from caller if was to refresh.
     */
    buildResultsFromSearches: function( searches, frChannel ) {

        var vChannel = frChannel.request('vChannel'),
            currentPageNumber = vChannel.request('currentPageNumber'),
            activeDocument = vChannel.request('activeDocument'),
            state = frChannel.request('state'),
            indexesCache = state.get('subsequentWordIndexCache'),
            pageCollection = activeDocument.pageCollection, //--now needed to put page models on notes, shapes -- should break that into ids ...
            activeDocumentTextModel = activeDocument.getDocumentTextModel(), // getOriginalWordModelById -- maybe want to pass in to see dependencies
            activeDocumentDerivedWordModels = activeDocumentTextModel.getDerivedWordModels();

        searches.forEach( function( search ) {
            this._buildResultsFromSearch( search, indexesCache, activeDocumentDerivedWordModels, pageCollection, currentPageNumber );
        }, this );

        //this.pageTree.getRoot().sortChildren(); // TEMP test ... this breaks more than helps


    },


    /* Now kind of like the same as search to being with -- now we only do one at a time .... */
    addSearchesToResults: function( searches, frChannel ) {

        this.buildResultsFromSearches( searches, frChannel );
        this.updateTreeStateFromHits( frChannel.request('state').get('showResultsByPage') );

    },

    /* Central point to build from search */
    _buildResultsFromSearch: function( search, indexesCache, activeDocumentDerivedWordModels, pageCollection, currentPageNumber ) {

        /**
         * Get the index to search -- for now assuming one search type with consecutive words -- may later need factory depending on search type
         * Alt here for clarity would first be getting all the indexes for each search term and not building on the fly.
         * -- but prob not great no that we can add searches to existing results
         */

        var index = this._getIndexForSearch( search, indexesCache, activeDocumentDerivedWordModels );

        /**
         * Now 'search' index for hits.
         * Each one could be like a doc if using a search library.
         * TODO: diff fn -- create hits from found words ... I think this get broken up!
         */

        var indexHitModels = index.getIndexHits( search.get('sanitizedSearchTerm') );

        /* Add to appropriate models */
        this._addHitsFromFoundIndexHits( search, indexHitModels, activeDocumentDerivedWordModels, pageCollection, currentPageNumber );

    },


    _getIndexForSearch: function( search, stateIndexesCache, activeDocumentDerivedWordModels  ) {

        var index = null,
            searchTerm = search.get('sanitizedSearchTerm'), // TODO: fn -- get text to search on model: must already validated
            nSearchTerms = searchTerm.split(' ').length; // Note: this is already validated

        if ( stateIndexesCache[nSearchTerms] ) {

            index = stateIndexesCache[nSearchTerms];

        } else {

            /* Depending on the searchType, may want different Searcher -- and later way to process it */
            index = new TextSearcher({
                searchOptions: search.get('searchOptions'),
                nSearchTerms: nSearchTerms,
                wordModels: activeDocumentDerivedWordModels
            });

            stateIndexesCache[nSearchTerms] = index;
        }

        return index;

    },


    /**
     * Now central entry point for adding object to appropriate data structures.
     */
    _addHitsFromFoundIndexHits: function( search, indexHitModels, activeDocumentDerivedWordModels, pageCollection, currentPageNumber ) {


        indexHitModels.forEach( function( indexHitModel ) {

            // console.log( JSON.stringify( _.result( PageResult.prototype, 'defaults' ) ) ); // SOMEHOW THIS WAS GETTING CHANGED!
            /* First create a pageID x word models array of the results from which to create the hits collection -- words must be on the same page. */
            var pageIdByWordsArray = indexHitModel.getWordsByPage( activeDocumentDerivedWordModels );

            /**
             * Now loop through the hits words models (separated by pages) to create the hit models
             * Hits must all be on the same page ( even for derived/dashed words that could cross pages )
             */

            _.each( pageIdByWordsArray , function(pgWords) {

                var firstWord = pgWords[0],
                    pageNumber = firstWord.get('pageNumber'),
                    pageId = firstWord.get('pageId'),
                    page = pageCollection.findWhere({pageId: pageId});   // Will need the corresponding page model


                var topDownResult = this.getTopDownResults().getResultByPageAndSearchId( pageId, search.cid ),
                    pageNote = null;


                if ( topDownResult ) {

                    pageNote = topDownResult.getNote();

                } else
                {
                    pageNote = FindAndRedactNoteModelConverter.getResultPageNoteModel( search.get('noteModel'), page, search.cid );
                    topDownResult = this.getTopDownResults().addNewResult( pageId, search.cid, pageNote, search );
                }


                var pgNoteId = pageNote.cid,
                    hitId = this.hits.length; // ( TODO: now in order of how added, could create a unique id ) -- search, pageNoteId, hit number of it ) -- BUT MAYBE WE WANT THAT DIFFERENT IF COMBO HITS LATER ON ...

                /**
                 * Hits needs a separate shape from the parent ...
                 * this is a model it needs a new cid -- it can't be the shape if we pass it to another collection
                 * issue is to put in a different collection we need a different model for each
                 * try this to stop bleeding with fucking bbone ids
                 * !Now only one shape, could be composed of multiple words -- a hit can only have one shape!
                 */
                var shape = FindAndRedactNoteModelConverter.cloneShapeModel( pageNote, pageNote.shape, page );

                var hit = new Hit({

                    id: hitId, // TODO: with adding, i think we use the key

                    //key: 'S' + currentSearchKey + '_' + // an identifier

                    pageNumber: pageNumber,
                    pageId: pageId,
                    searchModelId: search.cid, // could use another link pageResults[pageId].getSearchResult( currentSearchKey ).
                    search: search,
                    pageNoteId: pgNoteId,

                    words: pgWords,  // derived (not multi-page) or from the original page-level ( if multi-page)
                    shape: shape

                });


                hit.setPreviewTextTemplateContext( activeDocumentDerivedWordModels );

                var derivedPts = hit.getDerivedShapeCoordinates();


                /**
                 * Note: currently no link back to the word models the represent --
                 * with pgWordModels being either derived or original ( if multi-page) -- there's currently no
                 * data structure with identifiers for them ( either in the derived or original word arrays ).
                 * And now with the squashed shapes -- 1 per hit -- there's currently no need.
                 * Maybe if want to get the area of the hit ???
                 * Maybe need a third array ( which the text previews could piggy back on) -- of the these models ...
                 * Could be easier to not squash the shapes and each would 1:1 model ... this is probably the answer
                 * ! Actually -- can just derive from the hit's words for time being; they are lumped anyway !
                 */

                shape.set({
                    uid: pgNoteId + '_' + hitId, // pageNoteId will keep between searches -- will be same format -- used for re-selection on re-render; don't use id
                    hitId: hitId,
                    points: derivedPts, // what drives the render from model
                    originalPointsInTenthsMM: derivedPts // store to reset
                });


                this.hits.add( hit );

                topDownResult.addHit( hit );

                this.pageTree.addHitFromSearch( hit, pageNote, currentPageNumber );

                this.searchTree.addHitFromSearch( hit, pageNote, currentPageNumber );

            }, this );


        }, this);




    },


    removeSearch: function( search ) {

        // Remove any hit models from the collection -- it's mututable
        var hitsOfSearch = this.hits.filter( function(m) {
            return m.get('search').cid === search.cid;
        });

        this.hits.remove( hitsOfSearch ); // Need to make null or destroy?

        this.getTopDownResults().removeAllResultsOfSearch( search.cid );

        this.pageTree.removeSearch( search.cid );
        this.searchTree.removeSearch( search.cid );

    },

    getPageTree: function() {
        return this.pageTree;
    },

    getSearchTree: function() {
        return this.searchTree;

    },

    getTopDownResults: function() {
        return this.topDownResults;
    },

    getSearchModels: function() {

        return this.getTopDownResults().getUniqueSearches();
    },


    getHits: function() {
        return this.hits;
    },

    hasResults: function() {
        return this.hits && this.hits.length > 0;

    },

    getHitById: function( hitId ) {

        return this.getHits().get( hitId );
    },

    getNumberOfHits: function() {
        return this.hits.length;
    },

    // TODO: data model could change here ...
    getAllShapesPerPage: function( pageId ) {

        return this.hits.getAllShapesPerPage( pageId );

    },

    getAppliedHits: function() {
        return this.hits.getAppliedHits();
    },

    /**
     * This goes top down.
     * Would traverse by the node, but this goes by hits.
     */
    updateTreeStateFromHits: function( isPageHierarchy ) {

        var tree = isPageHierarchy ? this.getPageTree() : this.getSearchTree();
        tree.updateStateFromHits();

    },

    _clearResults: function() {

        /* Hits */
        this.hits.erase(); // deleting the notes models ... cleaning up references -- maybe remove the listeners

        this.topDownResults.clear();

        // Hierarchies --> trying just setting all to null: I don't believe need to destroy in case have listeners on them or anything I just set to null?
        // with live adding, not setting to null
        this.pageTree.reset();
        this.searchTree.reset();

    },

    hasHitsFromFloatingRedactionNotesOnPage: function( pageId ) {

        return this.getTopDownResults().pageHasResultsFromFloatingRedactions( pageId );

    },

    /**
     * Get an array of pageNotes to save from those that have hits,
     * also creating the note.shapes array (that we are to save) in the process,
     * derived from the shapes of the hits to apply.
     */
    getNotesToSaveFromAppliedHits: function() {

        var notes = [];

        this.getTopDownResults().getResults().forEach( function( tdr ) {

            var appliedHits = tdr.getAppliedHits();

            if ( appliedHits.length > 0 ) {

                var note = tdr.getNote();

                // Currently the hit only has one shape ( for find and redact )
                // Create a shapes array from the hits (an array of shape models to save with the note)
                note.shapes = appliedHits.map( function(h) {
                    return h.get('shape');
                });


                notes.push( note );
            }

        });

        return notes;

    },


    destroy: function() {

        this._clearResults();

    }


});







module.exports = SearchResults;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/SearchResults.js
 ** module id = 657
 ** module chunks = 0
 **/